import styled from "styled-components";
import CustomButton from "../../reusable-components/custom-button/CustomButton";

export const StyledCustomButton = styled(CustomButton)`
  margin-left: auto;
`;
